import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { GraduationCap } from 'lucide-react';
import { Layout } from '../../components/Layout';
import { trainingSections } from '../../data/trainingSections';
export function TrainingSectionPage() {
  const {
    section
  } = useParams();
  const current = trainingSections.find(s => s.slug === section);
  if (!current) {
    return <Navigate to={`/training/${trainingSections[0].slug}`} replace data-id="element-6362" data-mp="2qp1tilebmv15" />;
  }
  return <Layout data-id="element-6363" data-mp="2qr68bydrdeg7">
      <div className="mb-8" data-id="element-6364" data-mp="2vnmvap981mrp">
        <p className="text-sm font-medium text-slate-500 mb-1" data-id="element-6365" data-mp="2voxz2p2o2uit">
          Formazione ·{' '}
          {current.kind === 'operativa' ? 'Sezione operativa' : 'Sezione anagrafica'}
        </p>
        <h1 className="text-3xl font-bold text-seform-navy" data-id="element-6366" data-mp="35mu7380b59cp">{current.name}</h1>
        <p className="text-slate-500 mt-1" data-id="element-6367" data-mp="fxjtakkfpf7a">{current.description}</p>
      </div>

      <section aria-label={`Contenuto ${current.name}`} className="bg-white border border-dashed border-slate-300 rounded-2xl min-h-[420px] flex flex-col items-center justify-center text-center px-6" data-id="element-6368" data-mp="kvlfvfh2jwni">
        <div className="w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-4" data-id="element-6369" data-mp="3qwlptki8n5cq">
          <GraduationCap className="h-6 w-6 text-slate-400" data-id="element-6370" data-mp="3msw4d3wv13vx" />
        </div>
        <p className="font-semibold text-seform-navy" data-id="element-6371" data-mp="3hvdpkww5vug0">
          Sezione in fase di definizione
        </p>
        <p className="text-sm text-slate-500 mt-1 max-w-sm" data-id="element-6372" data-mp="3cw152isrizgl">
          I contenuti di questa schermata verranno costruiti a breve.
        </p>
      </section>
    </Layout>;
}